import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material"
import { useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../app/hooks"
import { RootState } from "../../../app/store"
import { fetchExpensesByDateThunk } from "../handle-expenses.slice"
import { fetchUsersThunk } from "../../users-list/UserListSlice"
import { useEffect } from "react"
import UserInterface from "../../../app/models/user-interface"

interface ExpenseFilterState {
  selectedUserId: string
  selectedDate: string
}

interface ExpenseFilterComponentProps {
  selectedUserId?: string
}

export default function ExpenseFilterComponent({ selectedUserId }: ExpenseFilterComponentProps) {
  const dispatch = useAppDispatch()
  const { users } = useAppSelector((state: RootState) => state.users)
  const [filterState, setFilterState] = useState<ExpenseFilterState>({
    selectedUserId: selectedUserId || "",
    selectedDate: new Date().toISOString().split('T')[0]
  })

  useEffect(() => {
    dispatch(fetchUsersThunk())
  }, [dispatch])

  // Auto-apply filter when selectedUserId is provided
  useEffect(() => {
    if (selectedUserId && filterState.selectedDate) {
      dispatch(fetchExpensesByDateThunk({
        date: filterState.selectedDate,
        userId: selectedUserId
      }))
    }
  }, [selectedUserId, filterState.selectedDate, dispatch])

  const handleFilterChange = (field: keyof ExpenseFilterState, value: string) => {
    setFilterState(prev => ({
      ...prev,
      [field]: value
    }))
  }

  const handleApplyFilter = () => {
    if (filterState.selectedDate) {
      dispatch(fetchExpensesByDateThunk({
        date: filterState.selectedDate,
        userId: filterState.selectedUserId || undefined
      }))
    }
  }

  const handleClearFilter = () => {
    setFilterState({
      selectedUserId: "",
      selectedDate: new Date().toISOString().split('T')[0]
    })
    // You might want to dispatch a clear action here
  }

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 3, p: 2, bgcolor: 'background.paper', borderRadius: 1 }}>
      <FormControl sx={{ minWidth: 200 }}>
        <InputLabel>Usuario</InputLabel>
        <Select
          value={filterState.selectedUserId}
          label="Usuario"
          onChange={(e) => handleFilterChange('selectedUserId', e.target.value)}
        >
          <MenuItem value="">
            <em>Todos los usuarios</em>
          </MenuItem>
          {users.map((user: UserInterface) => (
            <MenuItem key={user._id} value={user._id}>
              { user.user ?? "" } {user.name} {user.lastName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        label="Fecha"
        type="date"
        value={filterState.selectedDate}
        onChange={(e) => handleFilterChange('selectedDate', e.target.value)}
        InputLabelProps={{
          shrink: true,
        }}
        sx={{ minWidth: 150 }}
      />

      <Button 
        variant="contained" 
        onClick={handleApplyFilter}
        disabled={!filterState.selectedDate}
      >
        Filtrar
      </Button>

      <Button 
        variant="outlined" 
        onClick={handleClearFilter}
      >
        Limpiar
      </Button>
    </Box>
  )
} 